import { render, staticRenderFns } from "./modal-menu.vue?vue&type=template&id=2c41f3da&scoped=true&"
import script from "./modal-menu.vue?vue&type=script&lang=js&"
export * from "./modal-menu.vue?vue&type=script&lang=js&"
import style0 from "./modal-menu.vue?vue&type=style&index=0&id=2c41f3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41f3da",
  null
  
)

export default component.exports